/*eslint-disable */

import {
  bus
} from '@/main';
import toast from '@/services/toast';

const $ = window.jQuery = require('jquery');
export default {
  name: 'chat-room-pinned-popup',
  components: {},
  props: ['pinnedRoomID', 'pinnedRoomSTATUS'],
  data() {
    return {
      pinnedStatus: Boolean,
      pinnedText: '',
      submitted: false
    }
  },
  computed: {

  },
  mounted() {
    if (this.pinnedRoomSTATUS == true) {
      this.pinnedText = 'Unpin'
      this.pinnedStatus = false
    } else {
      this.pinnedText = 'Pin'
      this.pinnedStatus = true
    }
    document.body.classList.add('body_right_scroll_remove');
  },
  methods: {
    getAllRoomListAgain() {
      this.$store.dispatch('getAllLeftChatListDetailsFun').then((res) => {
          this.closePinnedChatRoomPopup()
        })
    },
    confirmedPinnedChatRoomPopup() {
      this.submitted = true
      var data = {
        room_id: this.pinnedRoomID,
        pin: this.pinnedStatus
      }
      this.$store.dispatch('selectedChatRoomPinnedFun', data).then((res) => {
        this.getAllRoomListAgain()
        if (res.data.data.is_group_chat) {
          bus.$emit('updateGroupInfoDataBus', res.data.data)
        } else {
          bus.$emit('updateCurrentUserChatUpperInfoDataBus', res.data.data)
        }
        toast.success(res.data.user_msg || res.data.msg);
      }).catch((err) => {
        toast.error(err.data.user_msg || err.data.msg);
        this.submitted = false;
      })
    },
    closePinnedChatRoomPopup() {
      $('body').removeClass('body_right_scroll_remove')
      bus.$emit('pinnedRoomPopupStateBus', false);
    }
  }
}